<template>
  <div id="app">
    <router-view/>
    <AskAIButton
      :key="'ai_assistant_' + $route.name"
      v-if="visible"
      :modal-id="modalId"
    />

  </div>
</template>

<style lang="scss">

</style>
<script>
import AskAIButton from "@/components/common/AskAIButton.vue";
export default {
  components: {AskAIButton},
  methods: {
    isUnderAccidentIncidentMainReport() {
      return this.$route.name === 'General' ||
        this.$route.name === 'Event' ||
        this.$route.name === 'Loss' ||
        this.$route.name === 'Cause' ||
        this.$route.name === 'CorrectiveAction' ||
        this.$route.name === 'PreventiveAction' ||
        this.$route.name === 'AirCompanyInstruction' ||
        this.$route.name === 'ShipParticular'
    }
  },
  computed : {
    visible() {
      return this.isUnderAccidentIncidentMainReport();
    },
    modalId() {
      if (this.isUnderAccidentIncidentMainReport()) {
        return 'accident-incident-main-report';
      }

      return '';
    }
  },

}

</script>
